export enum BarcodeMediumCode {
  CASO = "1",
  DG18 = "2",
  MEA = "3",
}

export const BarcodeMediumCodeDisplayName: Record<BarcodeMediumCode, string> = {
  [BarcodeMediumCode.CASO]: 'CASO',
  [BarcodeMediumCode.DG18]: 'DG18',
  [BarcodeMediumCode.MEA]: 'MEA',
};

export const BarcodeMediumCodeOptions: { label: string; value: BarcodeMediumCode }[] = [
  { label: BarcodeMediumCodeDisplayName[BarcodeMediumCode.CASO], value: BarcodeMediumCode.CASO },
  { label: BarcodeMediumCodeDisplayName[BarcodeMediumCode.DG18], value: BarcodeMediumCode.DG18 },
  { label: BarcodeMediumCodeDisplayName[BarcodeMediumCode.MEA], value: BarcodeMediumCode.MEA },
];

export enum BarcodeIdCode {
  IDR_ID = "1",
}

export const BarcodeIdCodeDisplayName: Record<BarcodeIdCode, string> = {
  [BarcodeIdCode.IDR_ID]: 'IDR-Id',
};

export const BarcodeIdCodeOptions: { label: string; value: BarcodeIdCode }[] = [
  { label: BarcodeIdCodeDisplayName[BarcodeIdCode.IDR_ID], value: BarcodeIdCode.IDR_ID },
];


export enum BarcodeWaterCode {
  WATER = "1",
}

export const BarcodeWaterCodeDisplayName: Record<BarcodeWaterCode, string> = {
  [BarcodeWaterCode.WATER]: 'Wasser',
};

export const BarcodeWaterCodeOptions: { label: string; value: BarcodeWaterCode }[] = [
  { label: BarcodeWaterCodeDisplayName[BarcodeWaterCode.WATER], value: BarcodeWaterCode.WATER },
];

